// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__c9mzZ","selected":"Chip_selected__1we3B"};